<div *ngIf="duration !== null" class="api-call-timer">
    <span class="timer-label">{{ 'report.common.loadTime' | translate }}:</span>
    <span class="timer-value">{{ durationInSeconds }}s</span>
    <span class="timer-ms">({{ durationInMilliseconds }}ms)</span>
</div>
